import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { EModelName } from './model-name';

const UserInfoSchema = new mongoose.Schema({
  company: { type: mongoose.Schema.Types.ObjectId, ref: EModelName.CompanyInfo },
  emails: {
    type: [String],
    required: true,
  },
  fullName: { type: String },
  linkedinProfileImage: { type: String },
  linkedinProfileUrl: { type: String },
  careerSummary: { type: String },
  experiences: { type: [mongoose.Schema.Types.Mixed] },
  position: { type: String },
  location: { type: String },
  confident: { type: Boolean },
  funFact: { type: String },
  educationSummary: { type: String },
  education: { type: [mongoose.Schema.Types.Mixed] },
  languages: { type: [String] },
  publications: { type: [mongoose.Schema.Types.Mixed] },
  awards: { type: [mongoose.Schema.Types.Mixed] },
  volunteerWork: { type: [mongoose.Schema.Types.Mixed] },
  otherEmails: { type: [String] },
  created: { type: Date, default: Date.now() },
  lastUpdated: { type: Date },
});

export type T_UserInfoBase = InferSchemaType<typeof UserInfoSchema>;

// Extend the type to add proper typing for complex nested objects
export interface T_UserInfo extends Omit<T_UserInfoBase, 'experiences' | 'education' | 'publications' | 'awards' | 'volunteerWork'> {
  experiences?: {
    startsAt?: string;
    endsAt?: string;
    company?: string;
    title?: string;
    description?: string;
    location?: string;
    duration?: string;
    companyUrl?: string;
    positions?: {
      title?: string;
      subtitle?: string;
      description?: string;
      meta?: string;
      duration?: string;
      start_date?: string;
      end_date?: string;
      duration_short?: string;
    }[];
  }[];
  education?: {
    startsAt?: string;
    endsAt?: string;
    fieldOfStudy?: string;
    degreeName?: string;
    title?: string;
    meta?: string;
    url?: string;
    details?: string;
  }[];
  publications?: {
    name?: string;
    description?: string;
    publishedYear?: number;
    url?: string;
  }[];
  awards?: {
    title?: string;
    description?: string;
    issuer?: string;
    issuedOn?: {
      year?: number;
      month?: number;
      day?: number;
    };
  }[];
  volunteerWork?: {
    title?: string;
    description?: string;
    cause?: string;
    info?: string;
    startsAt?: string;
    endsAt?: string;
  }[];
}

export type T_UserInfoDocument = T_UserInfo &
  Document & {
    _id: string;
  };

export { UserInfoSchema };
